/** Values of the Branch `~feature` parameter the app acts on. */
export enum DeepLinkFeatures {
  UserInvitation = 'UserInvitation',
  OnboardingPrefill = 'onboarding-prefill',
}
